import { initializeApp } from "firebase/app";
import { initializeAppCheck, ReCaptchaV3Provider } from "firebase/app-check";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyCdwlVPKC0Cu6_QfL1Ib8TA-9_5fKENanw",
  authDomain: "duomila-app-ascoli.firebaseapp.com",
  projectId: "duomila-app-ascoli",
  storageBucket: "duomila-app-ascoli.firebasestorage.app",
  messagingSenderId: "731778283942",
  appId: "1:731778283942:web:fd755b1c5aa4cad9097767",
};

const RECAPTCHA_SITE_KEY = "6LeXzd4sAAAAABstGEjebd5D9k2m7yZCRhbfW2HO";

const isDev = process.env.NODE_ENV === "development";

if (isDev && typeof window !== "undefined") {
  // eslint-disable-next-line no-restricted-globals
  self.FIREBASE_APPCHECK_DEBUG_TOKEN = true;
}

export const firebaseApp = initializeApp(firebaseConfig);

let _appCheck = null;
try {
  _appCheck = initializeAppCheck(firebaseApp, {
    provider: new ReCaptchaV3Provider(RECAPTCHA_SITE_KEY),
    isTokenAutoRefreshEnabled: true,
  });
} catch (e) {
  console.warn("[App Check] init failed, continuing without token:", e?.message);
}

export const appCheck = _appCheck;

export const db = getFirestore(firebaseApp);
